{
  "INBOX_MGMT": {
    "HEADER": "Prejemniki",
    "DESCRIPTION": "Kanal je način komunikacije, ki ga vaša stranka izbere za interakcijo z vami. Nabiralnik je mesto, kjer upravljate interakcije za določen kanal. Vključuje lahko komunikacijo iz različnih virov, kot so e-pošta, klepet v živo in družbena omrežja.",
    "LEARN_MORE": "Izvedite več o prejemnikih",
    "COUNT": "{n} poštni predal | {n} poštni predali",
    "SEARCH_PLACEHOLDER": "Išči nabiralnike...",
    "NO_RESULTS": "Ni najdenih nobenih poštnih predalov, ki ustrezajo vašemu iskanju",
    "RECONNECTION_REQUIRED": "Vaš poštni predal je odklopljen. Novi sporočila ne boste prejeli, dokler ga ne ponovno pooblastite.",
    "CLICK_TO_RECONNECT": "Kliknite tukaj za ponovno povezavo.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Dokončaj registracijo",
    "LIST": {
      "404": "Ta račun nima pripetih prejemnikov."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Izberite kanal",
        "BODY": "Choose the provider you want to integrate with Chatwoot."
      },
      "INBOX": {
        "TITLE": "Ustvari poštni predal",
        "BODY": "Avtenticirajte svoj račun in ustvarite nabiralnik."
      },
      "AGENT": {
        "TITLE": "Dodaj agente",
        "BODY": "Dodajte agente v ustvarjeni prejemnik."
      },
      "FINISH": {
        "TITLE": "Tukaj je!",
        "BODY": "Pripravljeni ste za začetek!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Ime prejemnika",
        "PLACEHOLDER": "Vnesite ime vašega nabiralnika (npr. Acme Inc)",
        "ERROR": "Prosimo, vnesite veljavno ime nabiralnika"
      },
      "WEBSITE_NAME": {
        "LABEL": "Ime spletnega mesta",
        "PLACEHOLDER": "Vnesite ime vaše spletne strani (npr. Acme Inc)"
      },
      "FB": {
        "HELP": "PS: By signing in, we only get access to your Page's messages. Your private messages can never be accessed by Chatwoot.",
        "CHOOSE_PAGE": "Izberite stran",
        "CHOOSE_PLACEHOLDER": "Izberite stran s seznama",
        "INBOX_NAME": "Ime prejemnika",
        "ADD_NAME": "Dodajte ime za vaš prejemnik",
        "PICK_NAME": "Izberite ime za vaš nabiralnik",
        "PICK_A_VALUE": "Izberite vrednost",
        "CREATE_INBOX": "Ustvari poštni predal"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continue with Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Povežite svoj Instagram profil",
        "HELP": "To add your Instagram profile as a channel, you need to authenticate your Instagram Profile by clicking on 'Continue with Instagram' ",
        "ERROR_MESSAGE": "There was an error connecting to Instagram, please try again",
        "ERROR_AUTH": "There was an error connecting to Instagram, please try again",
        "NEW_INBOX_SUGGESTION": "Ta Instagram račun je bil prej povezan z drugim vhodnim predalom in je bil zdaj sem prenesen. Vsa nova sporočila se bodo prikazovala tukaj. Stari vhodni predal ne bo več mogel pošiljati ali prejemati sporočil za ta račun.",
        "DUPLICATE_INBOX_BANNER": "Ta Instagram račun je bil prenesen v nov vhodni predal kanala Instagram. Iz tega vhodnega predala ne boste več mogli pošiljati/prejemati Instagram sporočil.",
        "SETTINGS_RESTRICTED_WARNING": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
        "STATUS_LINK": "View status update"
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Nadaljuj s TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Povežite svoj TikTok profil",
        "HELP": "Če želite dodati svoj TikTok profil kot kanal, se morate prijaviti s svojim TikTok profilom tako, da kliknete »Nadaljuj s TikTok« ",
        "ERROR_MESSAGE": "Pri povezovanju s TikTok je prišlo do napake, prosimo, poskusite znova",
        "ERROR_AUTH": "Pri povezovanju s TikTok je prišlo do napake, prosimo, poskusite znova",
        "NORTH_AMERICA_WARNING": "TikTok connections for North American accounts are temporarily unavailable while we wait for an update from the TikTok team."
      },
      "TWITTER": {
        "HELP": "To add your Twitter profile as a channel, you need to authenticate your Twitter Profile by clicking on 'Sign in with Twitter' ",
        "ERROR_MESSAGE": "There was an error connecting to Twitter, please try again",
        "TWEETS": {
          "ENABLE": "Create conversations from mentioned Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Spletni kanal",
        "DESC": "Ustvarite kanal za vašo spletno stran in začnite podpirati svoje stranke prek našega spletnega pripomočka.",
        "LOADING_MESSAGE": "Ustvarjanje kanala za podporo na spletni strani",
        "CHANNEL_AVATAR": {
          "LABEL": "Channel Avatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Prosimo, vnesite veljaven URL"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domena spletne strani",
          "PLACEHOLDER": "Enter your website domain (eg: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Dobrodošel naslov",
          "PLACEHOLDER": "Hi there !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Pozdravni slogan",
          "PLACEHOLDER": "Povezovanje z nami je preprosto. Vprašajte nas karkoli ali delite svoje mnenje."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Sporočilo pozdrava kanala",
          "PLACEHOLDER": "Acme Inc typically replies in a few hours."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Omogoči pozdrav kanala",
          "HELP_TEXT": "Samodejno pošlji pozdravna sporočila, ko stranke začnejo pogovor in pošljejo svoje prvo sporočilo.",
          "ENABLED": "Omogočeno",
          "DISABLED": "Onemogočeno"
        },
        "REPLY_TIME": {
          "TITLE": "Nastavi čas odgovora",
          "IN_A_FEW_MINUTES": "Čez nekaj minut",
          "IN_A_FEW_HOURS": "Čez nekaj ur",
          "IN_A_DAY": "Čez en dan",
          "HELP_TEXT": "Ta čas odgovora bo prikazan na pripomočku za klepet v živo"
        },
        "WIDGET_COLOR": {
          "LABEL": "Barva pripomočka",
          "PLACEHOLDER": "Posodobi barvo pripomočka, uporabljeno v pripomočku"
        },
        "SUBMIT_BUTTON": "Ustvari poštni predal",
        "API": {
          "ERROR_MESSAGE": "Nismo mogli ustvariti kanala spletne strani, prosimo, poskusite znova"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp kanal",
        "DESC": "Integrirajte Twilio in začnite podpirati svoje stranke prek SMS ali WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "SID računa",
          "PLACEHOLDER": "Vnesite SID računa Twilio",
          "ERROR": "To polje je obvezno"
        },
        "API_KEY": {
          "USE_API_KEY": "Uporabi overjanje z API ključem",
          "LABEL": "SID API ključa",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "To polje je obvezno"
        },
        "API_KEY_SECRET": {
          "LABEL": "Skrivnost API ključa",
          "PLACEHOLDER": "Vnesite svojo skrivnost API ključa",
          "ERROR": "To polje je obvezno"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID storitve za sporočila",
          "PLACEHOLDER": "Vnesite SID storitve za sporočila Twilio",
          "ERROR": "To polje je obvezno",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Vrsta kanala",
          "ERROR": "Prosimo, izberite vrsto kanala"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Please enter your Twilio Auth Token",
          "ERROR": "To polje je obvezno"
        },
        "CHANNEL_NAME": {
          "LABEL": "Ime prejemnika",
          "PLACEHOLDER": "Prosimo, vnesite ime prejemnika",
          "ERROR": "To polje je obvezno"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonska številka",
          "PLACEHOLDER": "Vnesite telefonsko številko, s katere bo sporočilo poslano.",
          "ERROR": "Prosimo, vnesite veljavno telefonsko številko, ki se začne z znakom `+` in ne vsebuje presledkov."
        },
        "API_CALLBACK": {
          "TITLE": "URL za povratni klic",
          "SUBTITLE": "V Twilio morate nastaviti URL za povratno klicanje sporočil, kot je navedeno tukaj."
        },
        "SUBMIT_BUTTON": "Ustvari Twilio kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo mogli preveriti pristnosti Twilio poverilnic, prosimo poskusite znova"
        }
      },
      "SMS": {
        "TITLE": "SMS kanal",
        "DESC": "Začnite podpirati svoje stranke prek SMS.",
        "PROVIDERS": {
          "LABEL": "Ponudnik API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Pasovna širina"
        },
        "API": {
          "ERROR_MESSAGE": "Ni nam uspelo shraniti SMS kanala"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID računa",
            "PLACEHOLDER": "Please enter your Bandwidth Account ID",
            "ERROR": "To polje je obvezno"
          },
          "API_KEY": {
            "LABEL": "API ključ",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "To polje je obvezno"
          },
          "API_SECRET": {
            "LABEL": "API skrivnost",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "To polje je obvezno"
          },
          "APPLICATION_ID": {
            "LABEL": "ID aplikacije",
            "PLACEHOLDER": "Please enter your Bandwidth Application ID",
            "ERROR": "To polje je obvezno"
          },
          "INBOX_NAME": {
            "LABEL": "Ime prejemnika",
            "PLACEHOLDER": "Prosimo, vnesite ime prejemnika",
            "ERROR": "To polje je obvezno"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonska številka",
            "PLACEHOLDER": "Prosimo, vnesite telefonsko številko, s katere bo sporočilo poslano.",
            "ERROR": "Prosimo, vnesite veljavno telefonsko številko, ki se začne s `+` in ne vsebuje presledkov."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to authenticate Bandwidth credentials, please try again"
          },
          "API_CALLBACK": {
            "TITLE": "URL za povratni klic",
            "SUBTITLE": "V Bandwidth morate nastaviti URL za povratno sporočilo na URL, naveden tukaj."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "WhatsApp kanal",
        "DESC": "Začnite podpirati svoje stranke prek WhatsAppa.",
        "PROVIDERS": {
          "LABEL": "Ponudnik API",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "WhatsApp Cloud",
          "WHATSAPP_CLOUD_DESC": "Hitro nastavljanje prek Meta",
          "TWILIO_DESC": "Povežite se prek poverilnic Twilio",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Izberite svojega ponudnika API",
          "DESCRIPTION": "Izberite svojega ponudnika WhatsApp. Povežete se lahko neposredno prek Meta, kar ne zahteva nastavitve, ali prek Twilio z uporabo svojih podatkov za prijavo."
        },
        "INBOX_NAME": {
          "LABEL": "Ime prejemnika",
          "PLACEHOLDER": "Prosimo, vnesite ime prejemnika",
          "ERROR": "To polje je obvezno"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonska številka",
          "PLACEHOLDER": "Prosimo, vnesite telefonsko številko, s katere bo poslano sporočilo.",
          "ERROR": "Prosimo, vnesite veljavno telefonsko številko, ki se začne s `+` in ne vsebuje presledkov."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "ID telefonske številke",
          "PLACEHOLDER": "Please enter the Phone number ID obtained from Facebook developer dashboard.",
          "ERROR": "Prosimo, vnesite veljavno vrednost."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "ID poslovnega računa",
          "PLACEHOLDER": "Please enter the Business Account ID obtained from Facebook developer dashboard.",
          "ERROR": "Prosimo, vnesite veljavno vrednost."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Žeton za preverjanje spletnega ključa",
          "PLACEHOLDER": "Vnesite potrditveni žeton, ki ga želite nastaviti za Facebook webhook.",
          "ERROR": "Prosimo, vnesite veljavno vrednost."
        },
        "API_KEY": {
          "LABEL": "API ključ",
          "SUBTITLE": "Configure the WhatsApp API key.",
          "PLACEHOLDER": "Ključ API",
          "ERROR": "Prosimo, vnesite veljavno vrednost."
        },
        "API_CALLBACK": {
          "TITLE": "URL za povratni klic",
          "SUBTITLE": "V Facebook razvijalskem portalu morate nastaviti URL spletnega klica webhook in potrditveni žeton z vrednostmi, prikazanimi spodaj.",
          "WEBHOOK_URL": "URL spletnega kljuka",
          "WEBHOOK_VERIFICATION_TOKEN": "Žeton za preverjanje spletnega kljuka"
        },
        "SUBMIT_BUTTON": "Ustvari WhatsApp kanal",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Hitro nastavitev z Meta",
          "DESC": "Uporabite postopek WhatsApp Embedded Signup za hitro povezavo novih številk. Preusmerjeni boste na Meta, da se prijavite v svoj WhatsApp Business račun. Če imate skrbniški dostop, bo nastavitev potekala gladko in enostavno.",
          "BENEFITS": {
            "TITLE": "Prednosti vgrajene prijave:",
            "EASY_SETUP": "Ni potrebna ročna nastavitev",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Samodejna konfiguracija spletnega kljuka in telefonske številke"
          },
          "LEARN_MORE": {
            "TEXT": "Za več informacij o integrirani prijavi, cenah in omejitvah obiščite {link}.",
            "LINK_TEXT": "ta povezava"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Avtorizacija pri Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Nastavljam vaš WhatsApp poslovni račun",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "Registracija WhatsApp je bila preklicana",
          "SUCCESS_TITLE": "Poslovni račun WhatsApp je povezan!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Prejeli smo neveljavne poslovne podatke iz Facebooka. Poskusite znova.",
          "SIGNUP_ERROR": "Prišlo je do napake pri prijavi",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "MANUAL_FALLBACK": "Če je vaša številka že povezana s platformo WhatsApp Business (API), ali če ste tehnični ponudnik, ki vključuje svojo številko, uporabite {link} postopek",
          "MANUAL_LINK_TEXT": "ročni postopek nastavitve",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "Nismo mogli shraniti WhatsApp kanala"
        }
      },
      "VOICE": {
        "TITLE": "Glasovni kanal",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "Telefonska številka",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "SID računa",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "Auth Token",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "API ključ SID",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "Skrivnost API ključa",
            "PLACEHOLDER": "Vnesite skrivnost API ključa Twilio",
            "REQUIRED": "Zahtevan je skrivni ključ API"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Nastavite ta URL kot Voice URL na vaši Twilio telefonski številki in TwiML aplikaciji.",
          "TWILIO_STATUS_URL_TITLE": "URL za povratni klic statusa Twilio",
          "TWILIO_STATUS_URL_SUBTITLE": "Nastavite ta URL kot URL za povratni klic statusa na vaši Twilio telefonski številki."
        },
        "SUBMIT_BUTTON": "Ustvari glasovni kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo mogli ustvariti glasovnega kanala"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API kanal",
        "DESC": "Integrirajte se z API kanalom in začnite podpirati svoje stranke.",
        "CHANNEL_NAME": {
          "LABEL": "Ime kanala",
          "PLACEHOLDER": "Vnesite ime kanala",
          "ERROR": "To polje je obvezno"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Nastavite URL, na katerega želite prejemati povratne klice ob dogodkih.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Ustvari API kanal",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the api channel"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Email Channel",
        "DESC": "Integrirajte svoj e-poštni nabiralnik.",
        "CHANNEL_NAME": {
          "LABEL": "Ime kanala",
          "PLACEHOLDER": "Prosimo, vnesite ime kanala",
          "ERROR": "To polje je obvezno"
        },
        "EMAIL": {
          "LABEL": "E-pošta",
          "SUBTITLE": "Provide the email address where your customers send support requests.",
          "PLACEHOLDER": "E-pošta"
        },
        "SUBMIT_BUTTON": "Create Email Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the email channel"
        },
        "FINISH_MESSAGE": "Start forwarding your emails to the following email address.",
        "FINISH_MESSAGE_NO_FORWARDING": "Vaš e-poštni nabiralnik je bil uspešno ustvarjen! Za pošiljanje in prejemanje e-pošte morate nastaviti SMTP in IMAP poverilnice. Brez teh nastavitev e-pošte ne bo mogoče obdelovati.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "Kliknite tukaj",
        "CONFIGURE_SMTP_IMAP_TEXT": " za nastavitev IMAP in SMTP nastavitev"
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE kanal",
        "DESC": "Povežite se z LINE kanalom in začnite podpirati svoje stranke.",
        "CHANNEL_NAME": {
          "LABEL": "Ime kanala",
          "PLACEHOLDER": "Prosimo, vnesite ime kanala",
          "ERROR": "To polje je obvezno"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID LINE kanala",
          "PLACEHOLDER": "ID kanala LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Skrivnost kanala LINE",
          "PLACEHOLDER": "Skrivnost kanala LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Žeton kanala LINE",
          "PLACEHOLDER": "Žeton kanala LINE"
        },
        "SUBMIT_BUTTON": "Ustvari kanal LINE",
        "API": {
          "ERROR_MESSAGE": "Nismo mogli shraniti LINE kanala"
        },
        "API_CALLBACK": {
          "TITLE": "URL za povratni klic",
          "SUBTITLE": "V aplikaciji LINE morate nastaviti URL spletnega klica webhook na URL, naveden tukaj."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram kanal",
        "DESC": "Povežite se s Telegram kanalom in začnite podpirati svoje stranke.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Configure the bot token you have obtained from Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Ustvari Telegram kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo mogli shraniti Telegram kanala"
        }
      },
      "AUTH": {
        "TITLE": "Izberite kanal",
        "DESC": "Chatwoot supports live-chat widgets, Facebook Messenger, WhatsApp, Emails, etc., as channels. If you want to build a custom channel, you can create it using the API channel. To get started, choose one of the channels below.",
        "TITLE_NEXT": "Dokončajte nastavitev",
        "TITLE_FINISH": "Tukaj je!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Spletna stran",
            "DESCRIPTION": "Ustvari pripomoček za klepet v živo"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "Povežite svojo Facebook stran"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Podprite svoje stranke na WhatsAppu"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "E-pošta",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Povežite svoj kanal Line"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Povežite svoj Instagram račun"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Povežite svoj TikTok račun"
          },
          "VOICE": {
            "TITLE": "Glas",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "Agentje",
        "DESC": "Tukaj lahko dodate agente za upravljanje vašega novo ustvarjenega nabiralnika. Dostop do vašega nabiralnika bodo imeli samo ti izbrani agentje. Agentje, ki niso del tega nabiralnika, ne bodo mogli videti ali odgovarjati na sporočila v tem nabiralniku, ko se prijavijo. <br> <b>PS:</b> Kot skrbnik, če potrebujete dostop do vseh nabiralnikov, se morate dodati kot agent v vse nabiralnike, ki jih ustvarite.",
        "VALIDATION_ERROR": "Dodajte vsaj enega agenta v svoj nov prejemnik",
        "PICK_AGENTS": "Izberite agente za prejemnik"
      },
      "DETAILS": {
        "TITLE": "Podrobnosti mape",
        "DESC": "Iz spodnjega spustnega seznama izberite Facebook stran, ki jo želite povezati s Chatwootom. Svojemu nabiralniku lahko tudi dodelite poljubno ime za lažjo prepoznavo."
      },
      "FINISH": {
        "TITLE": "Uspešno!",
        "DESC": "Uspešno ste integrirali svojo Facebook stran s Chatwootom. Naslednjič, ko vam bo stranka poslala sporočilo na stran, se bo pogovor samodejno prikazal v vašem nabiralniku.<br>Prav tako vam zagotavljamo skripto za widget, ki jo lahko enostavno dodate na svojo spletno stran. Ko bo ta aktivna na vaši spletni strani, vam bodo lahko stranke sporočila pošiljale neposredno od tam, brez uporabe zunanjih orodij, pogovor pa se bo prikazal tukaj, v Chatwootu.<br>Kul, kajne? Mi si vsaj prizadevamo biti :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Izberite ponudnika e-pošte s spodnjega seznama. Če vašega ponudnika ni na seznamu, lahko izberete možnost drugega ponudnika in vnesete IMAP in SMTP poverilnice."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Za začetek kliknite na gumb Prijava z Microsoft. Preusmerjeni boste na stran za prijavo v elektronsko pošto. Ko sprejmete zahtevane dovoljenja, boste preusmerjeni nazaj na korak ustvarjanja nabiralnika.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Prijava z Microsoft",
        "ERROR_MESSAGE": "Prišlo je do napake pri povezovanju z Microsoftom, prosimo, poskusite znova"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Za začetek kliknite na gumb Prijava z Google. Preusmerjeni boste na stran za prijavo v elektronsko pošto. Ko sprejmete zahtevana dovoljenja, boste preusmerjeni nazaj na korak ustvarjanja nabiralnika.",
        "SIGN_IN": "Prijava z Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Authenticating you with Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Something went wrong, Please refresh page...",
      "ERROR_FB_UNAUTHORIZED": "Nimate dovoljenja za izvedbo te akcije. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "CREATING_CHANNEL": "Ustvarjam vaš nabiralnik...",
      "TITLE": "Konfigurirajte podrobnosti nabiralnika",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Dodaj agente",
      "ADD_AGENTS": "Dodajam agente v vaš nabiralnik..."
    },
    "FINISH": {
      "TITLE": "Vaš predal je pripravljen!",
      "MESSAGE": "Zdaj lahko komunicirate s svojimi strankami prek novega kanala. Veselo podpiranje",
      "BUTTON_TEXT": "Pojdi tja",
      "MORE_SETTINGS": "Več nastavitev",
      "WEBSITE_SUCCESS": "Uspešno ste ustvarili kanal spletne strani. Kopirajte spodaj prikazano kodo in jo prilepite na svojo spletno stran. Naslednjič, ko bo kupec uporabil klepet v živo, se bo pogovor samodejno prikazal v vašem prejemniku.",
      "WHATSAPP_QR_INSTRUCTION": "Skenirajte zgornjo QR kodo za hiter preizkus vašega WhatsApp nabiralnika",
      "MESSENGER_QR_INSTRUCTION": "Skenirajte zgornjo QR kodo za hiter preizkus vašega Facebook Messenger nabiralnika",
      "TELEGRAM_QR_INSTRUCTION": "Skenirajte zgornjo QR kodo za hiter preizkus vašega Telegram nabiralnika"
    },
    "REAUTH": "Ponovno pooblastite",
    "VIEW": "Pogled",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Nastavitve nabiralnika so bile uspešno posodobljene",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Samodejna dodelitev je bila uspešno posodobljena",
        "ERROR_MESSAGE": "Nismo mogli posodobiti nastavitev nabiralnika. Prosimo, poskusite znova kasneje."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Omogočeno",
        "DISABLED": "Onemogočeno"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Omogočeno",
        "DISABLED": "Onemogočeno"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Ime pošiljatelja",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "Na primer:",
        "FRIENDLY": {
          "TITLE": "Prijazno",
          "FROM": "Od",
          "SUBTITLE": "Dodajte ime agenta, ki je poslal odgovor, v ime pošiljatelja, da bo prijazno."
        },
        "PROFESSIONAL": {
          "TITLE": "Strokovno",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Configure your business name",
          "PLACEHOLDER": "Vnesite ime vašega podjetja",
          "SAVE_BUTTON_TEXT": "Shrani"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Omogočeno",
        "DISABLED": "Onemogočeno"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Omogočeno",
        "DISABLED": "Onemogočeno"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Znova odpri isti pogovor",
        "DISABLED": "Ustvari nove pogovore",
        "ENABLED_DESCRIPTION": "Ko kontakt ponovno pošlje sporočilo, se bo prejšnji pogovor znova odprl.",
        "DISABLED_DESCRIPTION": "Vsakič, ko je prejšnji pogovor rešen, se ustvari nov pogovor."
      },
      "ENABLE_HMAC": {
        "LABEL": "Omogoči"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "AVATAR_DELETE_BUTTON_TEXT": "Delete Avatar",
      "CONFIRM": {
        "TITLE": "Potrdi brisanje",
        "MESSAGE": "Ali ste prepričani, da želite izbrisati ",
        "PLACE_HOLDER": "Prosimo, vnesite {inboxName} za potrditev",
        "YES": "Da, izbriši ",
        "NO": "Ne, obdrži "
      },
      "API": {
        "SUCCESS_MESSAGE": "Predalnik je bil uspešno izbrisan",
        "ERROR_MESSAGE": "Predalnika ni bilo mogoče izbrisati. Poskusite znova kasneje.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar nabiralnika je bil uspešno izbrisan",
        "AVATAR_ERROR_MESSAGE": "Avatar nabiralnika ni bilo mogoče izbrisati. Poskusite znova kasneje."
      }
    },
    "TABS": {
      "SETTINGS": "Nastavitve",
      "COLLABORATORS": "Sodelavci",
      "CONFIGURATION": "Konfiguracija",
      "CAMPAIGN": "Kampanje",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Delovni čas",
      "WIDGET_BUILDER": "Ustvarjalec pripomočkov",
      "BOT_CONFIGURATION": "Bot Configuration",
      "ACCOUNT_HEALTH": "Zdravje računa",
      "CSAT": "CSAT",
      "VOICE": "Glas",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      },
      "INBOUND": {
        "LABEL": "Allow incoming calls",
        "DESCRIPTION": "Let customers call this number. When turned off, incoming calls are declined automatically — agents aren't notified and no conversation is created. Agents can still place outgoing calls."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Nastavitve kanala",
    "WIDGET_FEATURES": "Funkcije pripomočka",
    "ACCOUNT_HEALTH": {
      "TITLE": "Upravljajte svoj WhatsApp račun",
      "DESCRIPTION": "Preverite stanje vašega WhatsApp računa, omejitve sporočil in kakovost. Po potrebi posodobite nastavitve ali odpravite težave",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Podatki o stanju niso na voljo",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Prikaži telefonsko številko",
          "TOOLTIP": "Telefonska številka, prikazana strankam"
        },
        "VERIFIED_NAME": {
          "LABEL": "Ime podjetja",
          "TOOLTIP": "Ime podjetja, potrjeno s strani WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Stanje prikazanega imena",
          "TOOLTIP": "Status preverjanja imena vašega podjetja"
        },
        "QUALITY_RATING": {
          "LABEL": "Ocena kakovosti",
          "TOOLTIP": "Ocena kakovosti WhatsApp za vaš račun"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Raven omejitve sporočanja",
          "TOOLTIP": "Dnevna omejitev sporočil za vaš račun"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Način računa",
          "TOOLTIP": "Trenutni način delovanja vašega WhatsApp računa"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K strank na 24h",
          "TIER_100K": "100K strank na 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Ocena ni na voljo"
        },
        "STATUSES": {
          "APPROVED": "Odobreno",
          "PENDING_REVIEW": "Čaka na pregled",
          "AVAILABLE_WITHOUT_REVIEW": "Na voljo brez pregleda",
          "REJECTED": "Zavrnjeno",
          "DECLINED": "Odbito",
          "NON_EXISTS": "Ne obstaja"
        },
        "MODES": {
          "SANDBOX": "Testno okolje",
          "LIVE": "V živo"
        }
      },
      "WEBHOOK": {
        "TITLE": "Konfiguracija spletnega klica Webhook",
        "DESCRIPTION": "Za prejemanje sporočil od strank za vaš WhatsApp Business račun je potreben URL Webhook.",
        "ACTION_REQUIRED": "Webhook ni konfiguriran",
        "REGISTER_BUTTON": "Registriraj spletni klic",
        "REGISTER_SUCCESS": "Spletni klic je bil uspešno registriran",
        "REGISTER_ERROR": "Registracija spletnega klica ni uspela. Prosimo, poskusite znova.",
        "CONFIGURED_SUCCESS": "Webhook je bil uspešno konfiguriran",
        "URL_MISMATCH": "URL spletnega klica se ne ujema"
      }
    },
    "SETTINGS": "Nastavitve",
    "FEATURES": {
      "LABEL": "Funkcije",
      "DISPLAY_FILE_PICKER": "Display file picker on the widget",
      "DISPLAY_EMOJI_PICKER": "Display emoji picker on the widget",
      "ALLOW_END_CONVERSATION": "Dovoli uporabnikom, da končajo pogovor iz pripomočka",
      "USE_INBOX_AVATAR_FOR_BOT": "Uporabite ime in avatar nabiralnika za bota"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Script",
      "MESSENGER_SUB_HEAD": "Place this button inside your body tag",
      "ALLOWED_DOMAINS": {
        "TITLE": "Dovoljene domene",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Skrivni ključ",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "Agentje",
      "INBOX_AGENTS_SUB_TEXT": "Dodajte ali odstranite agente iz tega nabiralnika",
      "AGENT_ASSIGNMENT": "Dodelitev pogovora",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Posodobi nastavitve dodelitve pogovorov",
      "UPDATE": "Posodobi",
      "ENABLE_EMAIL_COLLECT_BOX": "Enable email collect box",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Enable or disable email collect box on new conversation",
      "AUTO_ASSIGNMENT": "Omogoči samodejno dodeljevanje",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversations will continue over email if the contact email address is available.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Usmerjanje pogovorov",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "Nastavitve prejemnika",
      "INBOX_UPDATE_SUB_TEXT": "Posodobite nastavitve prejemnika",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Omogočite ali onemogočite samodejno dodeljevanje novih pogovorov agentom, dodanim v ta prejemnik.",
      "HMAC_VERIFICATION": "Preverjanje identitete uporabnika",
      "HMAC_DESCRIPTION": "S tem ključem lahko ustvarite skrivni žeton, ki se lahko uporabi za preverjanje identitete vaših uporabnikov.",
      "HMAC_LINK_TO_DOCS": "Več si lahko preberete tukaj.",
      "HMAC_MANDATORY_VERIFICATION": "Zahtevaj preverjanje identitete uporabnika",
      "HMAC_MANDATORY_DESCRIPTION": "Če je omogočeno, bodo zavrnjene zahteve, ki jih ni mogoče preveriti.",
      "INBOX_IDENTIFIER": "Identifikator prejemnika",
      "INBOX_IDENTIFIER_SUB_TEXT": "Uporabite žeton `inbox_identifier`, prikazan tukaj, za preverjanje pristnosti vaših API odjemalcev.",
      "FORWARD_EMAIL_TITLE": "Forward to Email",
      "FORWARD_EMAIL_SUB_TEXT": "Start forwarding your emails to the following email address.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Posredovanje e-pošte v vaš nabiralnik je trenutno onemogočeno na tej namestitvi. Za uporabo te funkcije mora to omogočiti vaš administrator. Prosimo, obrnite se nanj za nadaljnje ukrepe.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Dovoli sporočila po rešitvi pogovora",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Dovoli končnim uporabnikom pošiljanje sporočil tudi po tem, ko je pogovor rešen.",
      "WHATSAPP_SECTION_SUBHEADER": "This API Key is used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Enter the new API key to be used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_TITLE": "API ključ",
      "WHATSAPP_SECTION_UPDATE_TITLE": "Posodobi API ključ",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Vnesite nov API ključ tukaj",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "Posodobi",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "Vgrajena prijava za WhatsApp",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "Ta poštni predal je povezan prek vgrajene prijave WhatsApp.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "Lahko ponovno konfigurirate ta nabiralnik za posodobitev nastavitev WhatsApp Business.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_MANUAL_TRANSFER_TITLE": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUBHEADER": "This inbox was connected through WhatsApp embedded signup, which is no longer supported. Enter the WhatsApp Cloud API credentials from your own Meta app to switch this inbox to a manual setup. Configure the webhook in your Meta app using the verification token above before switching.",
      "WHATSAPP_MANUAL_TRANSFER_PHONE_NUMBER_ID_LABEL": "Phone Number ID",
      "WHATSAPP_MANUAL_TRANSFER_BUSINESS_ACCOUNT_ID_LABEL": "ID poslovnega računa",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_LABEL": "API ključ",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_PLACEHOLDER": "Enter a permanent access token from your Meta app",
      "WHATSAPP_MANUAL_TRANSFER_BUTTON": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUCCESS": "Inbox switched to manual setup successfully.",
      "WHATSAPP_MANUAL_TRANSFER_ERROR": "Could not switch to manual setup. Please verify the credentials and try again.",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Nadgradite na vgrajeno prijavo WhatsApp za lažje upravljanje.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Povežite ta nabiralnik z WhatsApp Business za izboljšane funkcije in lažje upravljanje.",
      "WHATSAPP_CONNECT_BUTTON": "Poveži",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "ID aplikacije WhatsApp ni nastavljen. Obrnite se na svojega skrbnika.",
      "WHATSAPP_CONFIG_ID_MISSING": "ID konfiguracije WhatsApp ni nastavljena. Prosimo, obrnite se na svojega skrbnika.",
      "WHATSAPP_LOGIN_CANCELLED": "Prijava v WhatsApp je bila preklicana. Poskusite znova.",
      "WHATSAPP_WEBHOOK_TITLE": "Žeton za preverjanje spletnega kljuka",
      "WHATSAPP_WEBHOOK_SUBHEADER": "Ta žeton se uporablja za preverjanje pristnosti končne točke spletnega kljuka.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sinhroniziraj predloge",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Ročno sinhronizirajte predloge sporočil iz WhatsApp, da posodobite razpoložljive predloge.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sinhroniziraj predloge",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Sinhronizacija predlog uspešno začeta. Posodobitev lahko traja nekaj minut.",
      "WHATSAPP_MANUAL_MIGRATION": {
        "BANNER": {
          "TITLE": "Manual setup recommended",
          "DESCRIPTION": "This inbox connects through the shared Meta app used for embedded signup, which recent Meta restrictions have affected. To avoid similar issues in the future, we recommend reconnecting it with your own Meta app.",
          "START": "Start manual migration",
          "GUIDE": "View guide"
        },
        "DIALOG": {
          "EYEBROW": "WhatsApp manual migration",
          "TITLE": "Reconnect WhatsApp inbox",
          "CLOSE": "Close",
          "ACTION_REQUIRED_TITLE": "Reconnect with your own Meta app",
          "ACTION_REQUIRED_DESCRIPTION": "Inboxes connected through your own Meta app are not affected by restrictions on the shared embedded signup app. This guided flow updates the WhatsApp API connection without creating a new inbox.",
          "GUIDE_LINK": "Open the manual setup guide",
          "PRESERVED_TITLE": "Preserved",
          "PRESERVED_DESCRIPTION": "Conversations, contacts, collaborators, routing, business hours, and inbox settings.",
          "UPDATED_TITLE": "Updated",
          "UPDATED_DESCRIPTION": "WABA ID, phone number ID, access token, and webhook configuration.",
          "WABA_ID": "WABA ID",
          "WABA_PLACEHOLDER": "Enter WABA ID",
          "WABA_HELP": "The WhatsApp Business Account that owns this phone number.",
          "PHONE_NUMBER_ID": "Phone Number ID",
          "PHONE_NUMBER_PLACEHOLDER": "Enter Phone Number ID",
          "PHONE_NUMBER_HELP": "Meta's unique ID for the WhatsApp number connected to this inbox.",
          "DISPLAY_PHONE_NUMBER": "Prikaži telefonsko številko",
          "DISPLAY_PHONE_NUMBER_PLACEHOLDER": "Enter display phone number",
          "DISPLAY_PHONE_NUMBER_HELP": "The customer-facing WhatsApp number. This cannot be changed during migration.",
          "ACCESS_TOKEN": "Permanent access token or system user token",
          "ACCESS_TOKEN_PLACEHOLDER": "Paste access token",
          "TOKEN_HELP_PREFIX": "The token must include",
          "TOKEN_HELP_MIDDLE": "Add",
          "TOKEN_HELP_SUFFIX": "for template sync and template management.",
          "MESSAGING_PERMISSION": "whatsapp_business_messaging.",
          "MANAGEMENT_PERMISSION": "whatsapp_business_management",
          "REVIEW_TITLE": "Review before reconnecting",
          "INBOX": "Inbox",
          "PHONE_NUMBER": "Telefonska številka",
          "NOT_ENTERED": "Not entered",
          "VERIFY_NOTICE": "Chatwoot will verify these credentials with Meta before applying any changes. If verification fails, the current configuration is left untouched.",
          "BACK": "Back",
          "CANCEL": "Cancel",
          "CONTINUE": "Nadaljuj",
          "REVIEW_MIGRATION": "Review migration",
          "RECONNECT": "Reconnect WhatsApp inbox"
        },
        "STEPS": {
          "BEFORE_YOU_START": {
            "TITLE": "Before you start",
            "DESCRIPTION": "This reconnects the WhatsApp API details for this inbox. Conversations, collaborators, routing, business hours, CSAT, and bot settings will be preserved."
          },
          "BUSINESS_DETAILS": {
            "TITLE": "Business details",
            "DESCRIPTION": "Enter the WhatsApp assets from the customer Meta Business account."
          },
          "ACCESS_TOKEN": {
            "TITLE": "Access token",
            "DESCRIPTION": "Paste a permanent access token or system user token with WhatsApp permissions."
          },
          "REVIEW_MIGRATION": {
            "TITLE": "Review migration",
            "DESCRIPTION": "Confirm the connection details before reconnecting this inbox. Chatwoot will verify the token, WABA, and phone number with Meta before applying changes."
          }
        }
      },
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Posodobi nastavitve obrazca pred klepetom"
    },
    "HELP_CENTER": {
      "LABEL": "Pomoč",
      "PLACEHOLDER": "Izberite Pomoč",
      "SELECT_PLACEHOLDER": "Izberite Pomoč",
      "NONE": "Brez",
      "REMOVE": "Odstrani Pomočnik za center",
      "SUB_TEXT": "Poveži Pomočnik za center z nabiralnikom"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Omejitev samodejne dodelitve",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Vnesite vrednost, večjo od 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Omejite največje število pogovorov iz tega nabiralnika, ki jih je mogoče samodejno dodeliti agentu"
    },
    "ASSIGNMENT": {
      "TITLE": "Dodelitev pogovora",
      "DESCRIPTION": "Samodejno dodeli dohodne pogovore razpoložljivim agentom glede na politike dodeljevanja",
      "ENABLE_AUTO_ASSIGNMENT": "Omogoči samodejno dodeljevanje pogovorov",
      "DEFAULT_RULES_TITLE": "Privzeta pravila dodeljevanja",
      "DEFAULT_RULES_DESCRIPTION": "Uporaba privzetega načina dodeljevanja za vse pogovore",
      "DEFAULT_RULE_1": "Najprej najstarejši pogovori",
      "DEFAULT_RULE_2": "Razporeditev po krožnem vrstnem redu",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Za ta nabiralnik uporabljam prilagojeno dodelitveno politiko",
      "CUSTOMIZE_POLICY": "Prilagodi s politiko dodeljevanja",
      "DELETE_POLICY": "Izbriši politiko",
      "POLICY_LABEL": "Pravila dodeljevanja",
      "ASSIGNMENT_ORDER_LABEL": "Vrstni red dodeljevanja",
      "ASSIGNMENT_METHOD_LABEL": "Metoda dodelitve",
      "POLICY_STATUS": {
        "ACTIVE": "Aktivno",
        "INACTIVE": "Neaktivno"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Najzgodnejše ustvarjeno",
        "LONGEST_WAITING": "Najdlje čakajoči"
      },
      "METHOD": {
        "ROUND_ROBIN": "V krogu",
        "BALANCED": "Uravnotežena dodelitev"
      },
      "UPGRADE_PROMPT": "Prilagojene politike dodelitve so na voljo v poslovnem paketu",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Privzeta politika povezana",
      "DEFAULT_POLICY_DESCRIPTION": "Povežite prilagojeno politiko dodeljevanja, da prilagodite, kako so pogovori dodeljeni agentom v tem nabiralniku.",
      "LINK_EXISTING_POLICY": "Poveži obstoječo politiko",
      "CREATE_NEW_POLICY": "Ustvari novo pravilo",
      "NO_POLICIES": "Ni najdenih pravil dodeljevanja",
      "VIEW_ALL_POLICIES": "Poglej vse politike",
      "CURRENT_BEHAVIOR": "Trenutno uporabljeno privzeto vedenje dodeljevanja:",
      "LINK_SUCCESS": "Pravilnik o dodelitvi je bil uspešno povezan",
      "LINK_ERROR": "Povezava pravilnika o dodelitvi ni uspela"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Izbrišem pravilo dodeljevanja?",
      "DELETE_CONFIRM_MESSAGE": "Ali ste prepričani, da želite odstraniti to pravilo dodeljevanja iz tega nabiralnika? Nabiralnik se bo vrnil na privzeta pravila dodeljevanja.",
      "CANCEL": "Prekliči",
      "CONFIRM_DELETE": "Izbriši",
      "DELETE_SUCCESS": "Pravilnik dodeljevanja je bil uspešno odstranjen",
      "DELETE_ERROR": "Odstranjevanje pravilnika dodeljevanja ni uspelo"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Ponovno pooblasti",
      "SUBTITLE": "Your Facebook connection has expired, please reconnect your Facebook page to continue services",
      "MESSAGE_SUCCESS": "Ponovna povezava uspešna",
      "MESSAGE_ERROR": "Prišlo je do napake, prosimo, poskusite znova"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Predklepetni obrazci omogočajo zajem informacij uporabnika, preden začne pogovor z vami.",
      "SET_FIELDS": "Polja obrazca pred klepetom",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Polja",
        "LABEL": "Oznaka",
        "PLACE_HOLDER": "Nadomestno besedilo",
        "KEY": "Ključ",
        "TYPE": "Vrsta",
        "REQUIRED": "Zahtevano"
      },
      "ENABLE": {
        "LABEL": "Enable pre chat form",
        "OPTIONS": {
          "ENABLED": "Da",
          "DISABLED": "Ne"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Sporočilo pred klepetom",
        "PLACEHOLDER": "To sporočilo bo uporabnikom vidno skupaj z obrazcem"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Obiskovalci naj pred začetkom klepeta vnesejo svoje ime in elektronski naslov"
      }
    },
    "CSAT": {
      "TITLE": "Omogoči CSAT",
      "SUBTITLE": "Samodejno sprožite ankete CSAT ob koncu pogovorov, da boste razumeli, kako se stranke počutijo glede svoje izkušnje s podporo. Spremljajte trende zadovoljstva in sčasoma prepoznajte področja za izboljšave.",
      "DISPLAY_TYPE": {
        "LABEL": "Vrsta prikaza"
      },
      "MESSAGE": {
        "LABEL": "Sporočilo",
        "PLACEHOLDER": "Prosimo, vnesite sporočilo, ki bo prikazano uporabnikom skupaj z obrazcem"
      },
      "BUTTON_TEXT": {
        "LABEL": "Besedilo gumba",
        "PLACEHOLDER": "Prosimo, ocenite nas"
      },
      "LANGUAGE": {
        "LABEL": "Jezik",
        "PLACEHOLDER": "Izberite jezik predloge"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Predogled sporočila",
        "TOOLTIP": "To se lahko rahlo razlikuje, ko je prikazano na platformi WhatsApp."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Odobreno s strani WhatsApp",
        "PENDING": "Čaka na odobritev WhatsApp",
        "REJECTED": "Meta je zavrnila predlogo",
        "DEFAULT": "Potrebno odobritev WhatsApp",
        "NOT_FOUND": "Predloga ni na voljo na platformi Meta."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "Predloga za WhatsApp je bila uspešno ustvarjena in poslana v odobritev",
        "ERROR_MESSAGE": "Ustvarjanje predloge za WhatsApp ni uspelo"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Uredi podrobnosti ankete",
        "DESCRIPTION": "Izbrisali bomo prejšnji predlog in ustvarili novega, ki bo ponovno poslan v odobritev za WhatsApp",
        "CONFIRM": "Ustvari nov predlog",
        "CANCEL": "Nazaj"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Preveri uporabnost",
        "HELPER_NOTE": "Pred oddajo preverite to sporočilo za izboljšanje ustreznosti Utility. Sistem ustvari namenski CSAT predlogo z gumbi za poročanje in jo odda kot Utility; Meta jo lahko glede na vsebino preklasificira kot Marketing.",
        "RESULT_LABEL": "Napoved kategorije Meta",
        "GUIDANCE_NOTE": "To je kontrola za usmerjanje, ne pa zagotovilo odobritve Meta.",
        "SUGGESTION_LABEL": "Predlagana varna preureditev za uporabnost",
        "APPLY": "Uporabi to preoblikovanje",
        "ERROR_MESSAGE": "Sporočila ni bilo mogoče analizirati. Poskusite znova.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Verjetno uporabno",
          "LIKELY_MARKETING": "Verjetno marketinško",
          "UNCLEAR": "Potrebna pojasnila"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Pravilo ankete",
        "DESCRIPTION_PREFIX": "Pošlji anketo, če je pogovor",
        "DESCRIPTION_SUFFIX": "katerakoli od oznak",
        "OPERATOR": {
          "CONTAINS": "vsebuje",
          "DOES_NOT_CONTAINS": "ne vsebuje"
        },
        "SELECT_PLACEHOLDER": "izberi oznake"
      },
      "NOTE": "Opomba: CSAT ankete se pošljejo samo enkrat na pogovor",
      "WHATSAPP_NOTE": "Opomba: Ko shranite, sistem ustvari namensko CSAT predlogo v WhatsAppu (uporablja se za zajem ocene in povratnih informacij v poročilih) in jo odda kot Utility za odobritev. Meta jo lahko glede na vsebino še vedno klasificira kot Marketing. Po odobritvi se ankete pošljejo le enkrat na pogovor v skladu s pravili ankete.",
      "API": {
        "SUCCESS_MESSAGE": "Nastavitve CSAT so bile uspešno posodobljene",
        "ERROR_MESSAGE": "Nastavitev CSAT ni bilo mogoče posodobiti. Prosimo, poskusite znova kasneje."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Nastavite svojo razpoložljivost",
      "SUBTITLE": "Nastavite svojo razpoložljivost na pripomočku za klepet v živo",
      "WEEKLY_TITLE": "Nastavite tedenske ure",
      "TIMEZONE_LABEL": "Izberi časovni pas",
      "UPDATE": "Posodobi nastavitve delovnega časa",
      "TOGGLE_AVAILABILITY": "Omogoči razpoložljivost za ta poštni predal",
      "UNAVAILABLE_MESSAGE_LABEL": "Sporočilo o nedosegljivosti za obiskovalce",
      "TOGGLE_HELP": "Omogočanje poslovne razpoložljivosti bo prikazalo razpoložljive ure na widgetu za klepet v živo, tudi če so vsi agenti brez povezave. Izven razpoložljivih ur lahko obiskovalce opozorite s sporočilom in predklepetnim obrazcem.",
      "DAY": {
        "DAY": "Dan",
        "AVAILABILITY": "Razpoložljivost",
        "HOURS": "Ure",
        "ENABLE": "Omogoči razpoložljivost za ta dan",
        "UNAVAILABLE": "Ni na voljo",
        "VALIDATION_ERROR": "Začetni čas mora biti pred končnim časom.",
        "CHOOSE": "Izberi"
      },
      "ALL_DAY": "Celi dan"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Nastavite svoje IMAP podatke",
      "NOTE_TEXT": "To enable SMTP, please configure IMAP.",
      "UPDATE": "Posodobi nastavitve IMAP",
      "TOGGLE_AVAILABILITY": "Omogoči konfiguracijo IMAP za ta poštni predal",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Nastavitve IMAP so bile uspešno posodobljene",
        "ERROR_MESSAGE": "Ni mogoče posodobiti nastavitev IMAP"
      },
      "ADDRESS": {
        "LABEL": "Naslov",
        "PLACE_HOLDER": "Address (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Vrata",
        "PLACE_HOLDER": "Vrata"
      },
      "LOGIN": {
        "LABEL": "Prijava",
        "PLACE_HOLDER": "Prijava"
      },
      "PASSWORD": {
        "LABEL": "Geslo",
        "PLACE_HOLDER": "Geslo"
      },
      "ENABLE_SSL": "Omogoči SSL",
      "AUTH_MECHANISM": "Authentication"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Ponovno pooblastite svoj MICROSOFT račun"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Nastavite svoje SMTP podatke",
      "UPDATE": "Posodobi nastavitve SMTP",
      "TOGGLE_AVAILABILITY": "Omogoči konfiguracijo SMTP za ta poštni predal",
      "TOGGLE_HELP": "Enabling SMTP will help the user to send email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Nastavitve SMTP so bile uspešno posodobljene",
        "ERROR_MESSAGE": "Posodobitev nastavitev SMTP ni bila mogoča"
      },
      "ADDRESS": {
        "LABEL": "Naslov",
        "PLACE_HOLDER": "Address (Eg: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Vrata",
        "PLACE_HOLDER": "Vrata"
      },
      "LOGIN": {
        "LABEL": "Prijava",
        "PLACE_HOLDER": "Prijava"
      },
      "PASSWORD": {
        "LABEL": "Geslo",
        "PLACE_HOLDER": "Geslo"
      },
      "DOMAIN": {
        "LABEL": "Domena",
        "PLACE_HOLDER": "Domena"
      },
      "ENCRYPTION": "Šifriranje",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Način preverjanja Open SSL",
      "AUTH_MECHANISM": "Authentication"
    },
    "NOTE": "Opomba: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "Prišlo je do napake, prosimo, poskusite znova"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Ime spletnega mesta",
          "PLACE_HOLDER": "Vnesite ime vaše spletne strani (npr. Acme Inc)",
          "ERROR": "Prosimo, vnesite veljavno ime spletnega mesta"
        },
        "WELCOME_HEADING": {
          "LABEL": "Pozdravni naslov",
          "PLACE_HOLDER": "Hi there!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Pozdravni slogan",
          "PLACE_HOLDER": "Povezovanje z nami je preprosto. Vprašajte nas karkoli ali delite svoje mnenje."
        },
        "REPLY_TIME": {
          "LABEL": "Čas odgovora",
          "IN_A_FEW_MINUTES": "Čez nekaj minut",
          "IN_A_FEW_HOURS": "Čez nekaj ur",
          "IN_A_DAY": "V enem dnevu"
        },
        "WIDGET_COLOR_LABEL": "Barva pripomočka",
        "WIDGET_BUBBLE": "Mehurček",
        "WIDGET_BUBBLE_POSITION_LABEL": "Položaj:",
        "WIDGET_BUBBLE_TYPE_LABEL": "Vrsta:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Klepetajte z nami",
          "LABEL": "Naslov zaganjalnika",
          "PLACE_HOLDER": "Klepetajte z nami"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Posodobi nastavitve pripomočka",
          "API": {
            "SUCCESS_MESSAGE": "Nastavitve pripomočka so bile uspešno posodobljene",
            "ERROR_MESSAGE": "Ni mogoče posodobiti nastavitev pripomočka"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Predogled",
          "SCRIPT": "Skript"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Levo",
          "RIGHT": "Desno"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standardno",
          "EXPANDED_BUBBLE": "Razširjen mehurček"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Privzeto",
        "CHAT": "Način klepeta"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Običajno odgovorimo v nekaj minutah",
        "IN_A_FEW_HOURS": "Običajno odgovorimo v nekaj urah",
        "IN_A_DAY": "Običajno odgovorimo v enem dnevu"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Začni pogovor",
        "CHAT_INPUT_PLACEHOLDER": "Vnesite svoje sporočilo"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Smo na spletu",
          "OFFLINE": "Trenutno nismo na voljo"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Pozdrav"
      },
      "BRANDING_TEXT": "Poganja Chatwoot",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Poveži se z Microsoftom"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Poveži se z Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Drugi ponudniki",
        "DESCRIPTION": "Povežite se z drugimi ponudniki"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Spletna stran",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "E-pošta",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API kanal",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Glas"
    }
  }
}
